var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 55",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "004---Word-Processing",
    fill: "rgb(0,0,0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 33.73c-.5522847 0-1 .4477153-1 1v10.27c0 1.1045695-.8954305 2-2 2h-16.2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h16.2c2.209139 0 4-1.790861 4-4v-10.27c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 40v3h-3c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h4c.5522847 0 1-.4477153 1-1v-4c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56 0h-52c-2.209139 0-4 1.790861-4 4v41c0 2.209139 1.790861 4 4 4h10.16c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-10.16c-1.1045695 0-2-.8954305-2-2v-31h56v6.41c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-16.41c0-2.209139-1.790861-4-4-4zm-54 12v-8c0-1.1045695.8954305-2 2-2h52c1.1045695 0 2 .8954305 2 2v8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 4c-1.65685425 0-3 1.34314575-3 3s1.34314575 3 3 3 3-1.34314575 3-3-1.34314575-3-3-3zm0 4c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1 1 .44771525 1 1-.44771525 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15 4c-1.6568542 0-3 1.34314575-3 3s1.3431458 3 3 3 3-1.34314575 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1 1 .44771525 1 1-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 4c-1.6568542 0-3 1.34314575-3 3s1.3431458 3 3 3 3-1.34314575 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1 1 .44771525 1 1-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 19h21c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-21c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 24h21c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-21c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 29h21c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-21c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 34h21c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-21c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 39h16.62c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-16.62c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 44h10c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-10c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 19h21c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-21c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 24h11c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-11c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 29h4c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15.208 54.07c.3696518.5404961.9821882.8637896 1.637.864.1614082-.0001647.3222172-.0196364.479-.058l10.826-2.626c.2397621-.0573906.4666673-.1591418.669-.3l19.581-13.544 4.112-2.843 5.757-3.982c1.8144934-1.2580752 2.2685124-3.7473514 1.015-5.565l-2.276-3.29c-1.2564589-1.8169996-3.7479788-2.2714277-5.565-1.015l-5.757 3.982-4.106 2.843-19.586 13.546c-.2025021.1389986-.37718.314694-.515.518l-6.279 9.206c-.4701543.6823593-.4669648 1.5849804.008 2.264zm26.692-23.32 4.55 6.58-18.099 12.513-4.551-6.579zm4.112-2.844 4.551 6.58-2.473 1.706-4.55-6.58zm6.58-4.551c.4363806-.301788.9747943-.417813 1.4967396-.3225388.5219452.0952742.9846444.3940393 1.2862604.8305388l2.275 3.289c.3021047.4364547.4183141.9751028.3230297 1.4972913-.0952844.5221886-.3942459.9850799-.8310297 1.2867087l-4.942 3.412-4.551-6.58zm-30.177 21.421 4.032 5.83-4.166 1.01-2.281-3.299zm-3.622 5.311 1.407 2.034-3.347.811z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.1c41f6cf616e46c7bae2ef35ce768fca.svg";
export { ForwardRef as ReactComponent };